<script setup>
import FsLightbox from "fslightbox-vue/v3";
import axios from "axios";
import { onMounted, ref } from "vue";
import { getYoutubeThumbnail } from "@/utils/useYoutube.js";

const toggler = ref(false);
const videos = ref([]);
const sources = ref([]);

async function getFeaturedVideos() {
    try {
        const res = await axios.get("/get-all-videos-data");
        videos.value =
            res.data.map((video) => ({
                ...video,
                thumbnail: getYoutubeThumbnail(video.url),
            })) || [];
    } catch (error) {
        console.error("Error fetching:", error);
    }
}

const openLightbox = (videoUrl) => {
    sources.value = [videoUrl]; // Set the lightbox source
    toggler.value = !toggler.value; // Toggle the lightbox
};

onMounted(() => {
    getFeaturedVideos();
});
</script>

<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 mx-auto pt-16 pb-8">
            <div
                class="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 2xl:gap-8 lg:gap-6 gap-4 xl:mt-8"
            >
                <div
                    @click="openLightbox(video.url)"
                    v-for="video in videos"
                    :key="video.id"
                    class="w-full 2xl:h-[240px] xl:h-[230px] md:h-[185px] h-[190px] block overflow-hidden border wow animate__animated animate__zoomIn cursor-pointer relative"
                >
                    <VLazyImage
                        :src="video.thumbnail"
                        alt="Video Thumbnail"
                        class="w-full h-full object-cover"
                    />
                    <div
                        class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30"
                    >
                        <button class="bg-red-600 px-4 py-2 rounded-lg">
                            <i
                                class="fa-brands fa-youtube text-3xl text-white"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <FsLightbox :toggler="toggler" :sources="sources" />
</template>

<style scoped></style>
